import { useRef } from 'react'
import classNames from 'classnames'

import { useIsScrollable } from '../../../hooks'
import { isListViewTypeWithPreview } from '../../../utils/listViewType'
import { MultipleViewTypeListActiveItemPreview } from '../MultipleViewTypeListActiveItemPreview'

import * as styles from './MultipleViewTypeListLayout.module.css'

function MultipleViewTypeListLayout({
  Preview = MultipleViewTypeListActiveItemPreview,
  children,
  className = styles.MultipleViewTypeListLayout,
  isEmptyItems,
  listViewType,
  pageScrollWrapperRef,
  previewProps,
}) {
  const containerRef = useRef(null)

  const { isVerticalScrollable } = useIsScrollable({
    externalRef: pageScrollWrapperRef,
  })

  const moddedClassName = classNames(className, {
    [styles.emptyItems]: isEmptyItems,
    [styles.scrollable]: isVerticalScrollable,
    [styles.withPreview]: isListViewTypeWithPreview(listViewType),
  })

  return (
    <div className={moddedClassName} ref={containerRef}>
      {children}
      {isListViewTypeWithPreview(listViewType) && Preview ? (
        <Preview {...previewProps} containerRef={containerRef} />
      ) : null}
    </div>
  )
}

export default MultipleViewTypeListLayout
